import React from 'react'
import logo from '../media/felsv/white_itprofis_logo.svg'

export default function LogoItProfis() {
  return (
    <div className='developed-by'>
      <div>Desarrollado por</div>
      <a
        target='_blank'
        href={`http://www.itprofis-gt.com`}
        className='logolink w-inline-block'
        rel='noreferrer'
      >
        <img src={logo} loading='lazy' width='126' alt='IT Profis logo' />
      </a>
    </div>
  )
}
